import { BreadcrumbCurrentLink, BreadcrumbRoot, PageHeader, PageTitle } from '@oaknorth/component-core-v2';
import { useFlag } from '@oaknorth/util-feature-flags';
import { T } from '@oaknorth/util-intl';
import { ResponsivePageContainer } from '@oaknorth/util-responsive';
import { PageNotFound, RouterTabs } from '@oaknorth/util-routing';

import { FeatureFlag } from '../../../../app/src/constants';

import { ReleaseNotesDisplay } from './ReleaseNotesDisplay';
import { ReleaseNoteDefinition } from './types';
import { useUpdateMostRecentViewedNoteDate } from './useUpdateMostRecentViewedNoteDate';

export interface ReleaseNotesProps {
  noteDefinitions: ReleaseNoteDefinition[];
}
const PAGE_TITLE = T`releaseNotes.title`;

export function ReleaseNotesPage({ noteDefinitions }: ReleaseNotesProps) {
  useUpdateMostRecentViewedNoteDate();
  const hasMonitoring = useFlag<boolean>(FeatureFlag.HAS_MONITORING);
  const hasScenarios = useFlag<boolean>(FeatureFlag.HAS_SCENARIOS);
  const hasClimate = useFlag<boolean>(FeatureFlag.HAS_CLIMATE);

  const showReleaseNotes = hasMonitoring || hasClimate || hasScenarios;

  if (!showReleaseNotes) {
    return <PageNotFound />;
  }

  return (
    <ResponsivePageContainer
      nav={
        <BreadcrumbRoot>
          <BreadcrumbCurrentLink isHomePage>{PAGE_TITLE}</BreadcrumbCurrentLink>
        </BreadcrumbRoot>
      }
    >
      <PageHeader>
        <PageTitle>{PAGE_TITLE}</PageTitle>
      </PageHeader>

      <RouterTabs
        id="release-notes"
        tabs={noteDefinitions.map((def) => ({
          id: def.id,
          label: def.label,
          content: <ReleaseNotesDisplay id={def.id} getContent={def.getContent} />,
        }))}
      />
    </ResponsivePageContainer>
  );
}
